module.exports = __webpack_public_path__ + "img/destination_dubai.a43067bd.jpg";